/** @format */

export enum AlertType {
  ALERT = 'alert',
  INFO = 'info',
  SUCCESS = 'success',
  WARN = 'warn',
}
